export default "__VITE_ASSET__DrmsZbMD__"